export default "__VITE_ASSET__DhHHjR_B__"